import React, { memo } from 'react';
import Dropdown from '@modules/insights/insightsDropdown';
import { GANTT_CHART_KEY, GANTT_CHART_TITLE } from '@model';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import SectionComment from 'src/ddvComment/SectionComment';
import SectionWidget from '@components/sectionWidget/SectionWidget';
import './ganttChartStyles.scss';
import { Spin, Empty } from 'antd';
import useInsightsChart, { InsightChartType } from '@hooks/useInsightsChart';
import { Loading } from '@components';

function GanttChart({ currentSubmoduleName }) {
  const { loading, saveData, data } = useInsightsChart(
    InsightChartType.GanttChart,
  );

  const handleSave = (tableData) => {
    saveData({
      id: data.id,
      moduleId: '',
      moduleType: 'insights',
      chartType: InsightChartType.GanttChart,
      data: tableData,
    });
  };

  // if (loading) {
  //   return (
  //     <div className="grid-display-switch-wrapper">
  //       <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
  //     </div>
  //   );
  // }

  return (
    <div className="insights-container insight-gantt-chart">
      <header>
        <Dropdown section={GANTT_CHART_KEY} />
        <SectionComment module={currentSubmoduleName} placement="bottomRight" />
      </header>
      {loading ? (
        <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
      ) : (
        <SectionWidget
          chartType="gantt"
          data={data?.data}
          handleSave={handleSave}
          chartPlaceholder={
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Data Available"
            />
          }
          showEmptyChart
          defaultShowGrid={false}
        />
      )}
    </div>
  );
}

export default CommentAnchor(memo(GanttChart), {
  shouldScrollInToView: (anchorRecord, anchorId) =>
    anchorRecord?.moduleName === anchorId,
  getAnchorIdFromProp(props) {
    return props.currentSubmoduleName;
  },
});
